import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import * as progressActions from '../store/actions';
import { progressActionTypes } from '../store/constants';
import { getProgressSubjects } from '../store/selectors';

import type { SagaIterator } from 'redux-saga';

export default function* (): Generator {
	yield all([
		takeLatest(
			progressActionTypes.GET_PROGRESS_OVERVIEW_REQUEST,
			handleProgressOverviewRequest,
		),
		takeLatest(progressActionTypes.GET_PROGRESS_DETAILS_REQUEST, handleProgressDetailsRequest),
	]);
}

export function* handleProgressOverviewRequest(): SagaIterator {
	try {
		const { data } = yield call(processRequest, ROUTES_API.PROGRESS_OVERVIEW, 'GET');

		yield put(progressActions.getProgressOverviewSuccess(data.activity, data.subjects));
	} catch (e) {
		yield put(progressActions.getProgressOverviewError(e));
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleProgressDetailsRequest({ payload }: any): SagaIterator {
	try {
		const { subcategoryId } = payload;

		let subjects = yield select(getProgressSubjects);

		yield delay(200);

		if (!subjects?.length) {
			const { data } = yield call(processRequest, ROUTES_API.PROGRESS_OVERVIEW, 'GET');
			subjects = data.subjects;
		}

		if (subjects?.length) {
			for (const subject of subjects) {
				const subcategories = ['missing_practice', 'previous_progress', 'progress'];
				let isFound = false;

				for (const category of subcategories) {
					if (isFound) break;
					if (subject.subcategories?.[category]?.length) {
						for (const subcategory of subject.subcategories[category]) {
							if (subcategory.id === subcategoryId) {
								yield put(progressActions.getProgressDetailsSuccess(subcategory));
								isFound = true;
								break;
							}
						}
					}
				}
			}
		}
	} catch (e) {
		yield put(progressActions.getProgressDetailsError(e));
		yield put(errorHandlerActions.handleError(e));
	}
}
